import { useCallback, useRef } from 'react';
import { useEntitlements } from '../contexts/EntitlementContext';
import AdService from '../services/adService';

export function useAdManager(sessionNumber, gameOverCount) {
  const { isAdFree } = useEntitlements();
  const interstitialCountRef = useRef(0);

  const onGameOver = useCallback(async () => {
    if (isAdFree) return;

    interstitialCountRef.current += 1;
    const count = interstitialCountRef.current;

    // Graduated ad schedule
    // Session 1: no ads
    // Sessions 2-5: every 5th game over
    // Sessions 6+: every 3rd game over
    let shouldShow = false;

    if (sessionNumber <= 1) {
      shouldShow = false;
    } else if (sessionNumber <= 5) {
      shouldShow = count % 5 === 0;
    } else {
      shouldShow = count % 3 === 0;
    }

    if (shouldShow) {
      try {
        await AdService.showInterstitial();
      } catch (err) {
        console.warn('[useAdManager] Interstitial failed:', err);
      }
    }
  }, [isAdFree, sessionNumber]);

  const showRewardedForPowerUp = useCallback(async (type) => {
    if (isAdFree) return false;

    try {
      const result = await AdService.showRewarded();
      return result?.completed || false;
    } catch (err) {
      console.warn('[useAdManager] Rewarded ad failed:', err);
      return false;
    }
  }, [isAdFree]);

  return { onGameOver, showRewardedForPowerUp };
}
